import {reqLncrnaDetailsFunction} from '@/api/home'
// module1.js
const module1 = {
    namespaced: true,
    state: {
      itemInfoData: {},
      linkSetting: {}
    },
    mutations: {
      // 变化
      setModalData(state, modalData) {
        if(modalData.isItemInfoData) {
          state.itemInfoData = modalData.itemInfoData
          if(localStorage.getItem('modalData')) {
            localStorage.setItem('modalData', JSON.stringify({...JSON.parse(localStorage.getItem('modalData')), itemInfoData: modalData.itemInfoData}))
          }else {
            localStorage.setItem('modalData', JSON.stringify({itemInfoData: modalData.itemInfoData, linkSetting: {}}))
          }
        }else if(modalData.isLinkSetting) {
          state.linkSetting = modalData.linkSetting

          if(localStorage.getItem('modalData')) {
            localStorage.setItem('modalData', JSON.stringify({...JSON.parse(localStorage.getItem('modalData')), linkSetting: modalData.linkSetting}))
          }else {
            localStorage.setItem('modalData', JSON.stringify({itemInfoData: {}, linkSetting: modalData.linkSetting}))
          }
        }else {
          state.itemInfoData = modalData.itemInfoData
          state.linkSetting = modalData.linkSetting
        }
      }
    },
    actions: {
      // 操作
      async getModalData({commit}, id) {
        const res = await reqLncrnaDetailsFunction(id)
        if(res.code === 1) {
          commit('setModalData', {itemInfoData: res.data, isItemInfoData: true})
        }
      },
    },
    getters: {
      // 获取
    }
  };
  
  export default module1;
  